import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { MaskLines } from "../site/Motion";

export const CtaBand = () => (
  <section className="relative overflow-hidden bg-[var(--signal)] py-20 text-[var(--ink)] md:py-28" data-testid="cta-band">
    <div className="mx-auto flex max-w-[1440px] flex-col gap-10 px-5 md:px-10 lg:flex-row lg:items-end lg:justify-between">
      <MaskLines lines={["Tell us the work.", "We'll staff it, run it", "and report on it."]}
        className="font-display text-5xl font-black uppercase leading-[0.88] md:text-7xl lg:text-8xl" />
      <div className="flex flex-wrap gap-3">
        <Link to="/quote" data-testid="cta-quote-button"
          className="group flex items-center gap-2 rounded-full bg-[var(--ink)] px-7 py-4 font-semibold text-[var(--bone)] transition-transform duration-300 hover:-translate-y-1">
          Request a quote <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:rotate-45" />
        </Link>
        <Link to="/careers" data-testid="cta-careers-button"
          className="rounded-full border-2 border-[var(--ink)] px-7 py-4 font-semibold transition-colors duration-300 hover:bg-[var(--ink)] hover:text-[var(--bone)]">
          Apply for a job
        </Link>
      </div>
    </div>
  </section>
);
